// Copyright (c) 2025 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  BatchGetTimesheetFieldConfigsRequestSchema,
  CreateTimesheetFieldOptionRequestSchema,
  CreateTimesheetFieldRequestSchema,
  DeleteTimesheetFieldOptionRequestSchema,
  DeleteTimesheetFieldRequestSchema,
  DisableTimesheetFieldOptionsRequestSchema,
  EnableTimesheetFieldOptionsRequestSchema,
  GenerateTimesheetFieldConfigsRequestSchema,
  ListTimesheetFieldOptionsRequestSchema,
  UpdateTimesheetFieldOptionRequestSchema,
  UpdateTimesheetFieldRequestSchema,
} from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"
import { Init } from "../../app/rpc"

export type Payload<T> = {
  request: T,
  onSuccess?: () => void,
  onError?: () => void,
}
export const listTimesheetFieldOptions = createAction<Init<typeof ListTimesheetFieldOptionsRequestSchema>>("timesheet-fields/list-timesheet-field-options")
export const generateTimesheetFieldConfigs = createAction<Init<typeof GenerateTimesheetFieldConfigsRequestSchema>>("timesheet-fields/generate-timesheet-field-configs")
export const batchGetTimesheetFieldConfigs = createAction<Init<typeof BatchGetTimesheetFieldConfigsRequestSchema>>("timesheet-fields/batch-get-timesheet-field-configs")
export const createTimesheetField = createAction<Payload<Init<typeof CreateTimesheetFieldRequestSchema>>>("timesheet-fields/create-timesheet-field")
export const updateTimesheetField = createAction<Payload<Init<typeof UpdateTimesheetFieldRequestSchema>>>("timesheet-fields/update-timesheet-field")
export type UpdateTimesheetFieldOptionPayload = Payload<Init<typeof UpdateTimesheetFieldOptionRequestSchema>> & { timesheetFieldId: string }
export const updateTimesheetFieldOption = createAction<UpdateTimesheetFieldOptionPayload>("timesheet-fields/update-timesheet-field-option")
export const deleteTimesheetField = createAction<Payload<Init<typeof DeleteTimesheetFieldRequestSchema>>>("timesheet-fields/delete-timesheet-field")
export const createTimesheetFieldOption = createAction<Payload<Init<typeof CreateTimesheetFieldOptionRequestSchema>>>("timesheet-fields/create-timesheet-field-option")
export type DeleteTimesheetFieldOptionPayload = Payload<Init<typeof DeleteTimesheetFieldOptionRequestSchema>> & { timesheetFieldId: string }
export const deleteTimesheetFieldOption = createAction<DeleteTimesheetFieldOptionPayload>("timesheet-fields/delete-timesheet-field-option")
export const enableTimesheetFieldOptions = createAction<Init<typeof EnableTimesheetFieldOptionsRequestSchema>>("timesheet-fields/enable-timesheet-field-options")
export const disableTimesheetFieldOptions = createAction<Init<typeof DisableTimesheetFieldOptionsRequestSchema>>("timesheet-fields/disable-timesheet-field-options")
